var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobirdLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.93 23.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.16,5.78c2.79-.97,5.96-1.24,8.83-.54,3.92.95,6.11,3.85,9.16,6.08,1.08.79,5.73,2.44,4.59-.44-1-2.52-3.37-4.68-5.52-6.21-3.37-2.4-6.92-3.23-11.07-3.27-3.25-.04-6.14.96-9.03,2.11C11.33,4.62-.49,5.62.2,0-.96,9.46,2.82,20.73,13.07,23.32c3.31.83,6.24,1.05,8.76-1.42,4.9-4.79.12-13.34-4.68-16.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.82,8.16c-.41.52-1.17.6-1.69.19-.52-.41-.6-1.17-.19-1.68.41-.52,1.17-.6,1.69-.19.52.41.6,1.17.19,1.68Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobirdLogoBlack);
export default __webpack_public_path__ + "static/media/globirdLogo-black.1335a77c62f323e2abf04eb1cc5a3495.svg";
export { ForwardRef as ReactComponent };